import { AdministratorList } from "../multyhealth/pages/admin/AdministratorList";
import { SettingList } from "../multyhealth/pages/setting/SettngList";
import { UserList } from "../multyhealth/pages/user/UserList";
import { SubscriberList } from "../multyhealth/pages/user/SubscriberList";
import { SupportList } from "../multyhealth/pages/support/SupportList";
import { CategoryList } from "../multyhealth/pages/product/CategoryList";
import { ProductList } from "../multyhealth/pages/product/ProductList";
import { CreateProduct } from "../multyhealth/pages/product/CreateProduct";
import { BondList } from "../multyhealth/pages/bond/BondList";
import { WithdrawalList } from "../multyhealth/pages/withdrawal/WithdrawalList";
import { CountryList } from "../multyhealth/pages/country/CountryList";
import { DatailProduct } from "../multyhealth/pages/product/DatailProduct";
import Ecommerce from "../multyhealth/Components/Ecommerce";
import { CountriesAvailable } from "../multyhealth/pages/countriesAvailable/CountriesAvailable";
import { OrderList } from "../multyhealth/pages/order/OrderList";
import { DetailOrder } from "../multyhealth/pages/order/DetailOrder";
import { DetailUser } from "../multyhealth/pages/user/DetailUser";
import { CreateOrder } from "../multyhealth/pages/order/CreateOrder";
import { UserCreate } from "../multyhealth/pages/user/UserCreate";
import { ReferralNetwork } from "../multyhealth/pages/user/ReferralNetwork";
import { InfluencerBonusList } from "../multyhealth/pages/influencerBonus/influencerBonusList";
import { LoyaltyList } from "../multyhealth/pages/loyalty/LoyaltyList";
import { ConfigLogistics } from "../multyhealth/pages/logistics/ConfigLogistics";
import { UserRanksList } from "../multyhealth/pages/loyalty/UserRanksList";
import {Banner} from "../multyhealth/pages/banner/Banner";
import CriticalAlertsAndInsights from "../multyhealth/pages/criticalAlertsAndInsights/CriticalAlertsAndInsights";

export const routes = [
  { path: '/dashboard', Component: <Ecommerce />, roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
  { path: '/administrator', Component: <AdministratorList />, roles: ['ADMIN'] },
  { path: '/setting', Component: <SettingList />, roles: ['ADMIN'] },
  { path: '/user', Component: <UserList />, roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
  { path: '/user/create', Component: <UserCreate />, roles: ['ADMIN','ADMIN_ASSISTANT'] },
  { path: '/user/detail/:id', Component: <DetailUser />, roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
  { path: '/user/referral-network/:id', Component: <ReferralNetwork />, roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
  { path: '/subscriber', Component: <SubscriberList />, roles: ['ADMIN'] },
  { path: '/support', Component: <SupportList />, roles: ['ADMIN'] },
  { path: '/category', Component: <CategoryList />, roles: ['ADMIN','ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/product', Component: <ProductList />, roles: ['ADMIN','ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/product/newProduct', Component: <CreateProduct />, roles: ['ADMIN','ADMIN_ASSISTANT'] },
  { path: '/product/edit/:id', Component: <CreateProduct />, roles: ['ADMIN','ADMIN_ASSISTANT'] },
  { path: '/product/detail/:id', Component: <DatailProduct />, roles: ['ADMIN', 'ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/order', Component: <OrderList />, roles: ['ADMIN', 'ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/order/create', Component: <CreateOrder />, roles: ['ADMIN', 'ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/order/detail/:id', Component: <DetailOrder />, roles: ['ADMIN', 'ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/influencer-bonus', Component: <InfluencerBonusList />, roles: ['ADMIN','ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/loyalty', Component: <LoyaltyList />, roles: ['ADMIN','ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/rank', Component: <UserRanksList />, roles: ['ADMIN','ADMIN_ASSISTANT','ASSISTANT'] },
  { path: '/withdrawal', Component: <WithdrawalList />, roles: ['ADMIN','ADMIN_ASSISTANT'] },
  { path: '/bond', Component: <BondList />, roles: ['ADMIN'] },
  { path: '/country', Component: <CountryList />, roles: ['ADMIN'] },
  { path: '/countries-available', Component: <CountriesAvailable />, roles: ['ADMIN'] },
  { path: '/logistics', Component: <ConfigLogistics />, roles: ['ADMIN','ASSISTANT'] },
  { path: '/banner', Component: <Banner />, roles: ["ADMIN", "ADMIN_ASSISTANT"] },
  { path: '/critical-alerts', Component: <CriticalAlertsAndInsights />, roles: ["ADMIN", "ADMIN_ASSISTANT"] },
];

